import { orgSelectors } from 'ducks/orgs'
import type { FilterType, GetDefaultFilterValuePropsType, HideFilterProps } from 'types/selectComponent'

export const StockAvailabilityFilter: FilterType = {
  key: 'require_stock',
  label: 'Current stock availability',
  options: [{ title: 'In stock', value: 'true' }],
  isHidden(opts: HideFilterProps) {
    const hardwareSupplier = orgSelectors.getSelectedHardwareSupplier(opts.reduxState)
    if (hardwareSupplier === 'city_plumbing') {
      return false
    } else if (hardwareSupplier === 'outlet') {
      const enableNewHardwareOrdering = opts.isFeatureEnabled('hardware_ordering', 'on')
      if (enableNewHardwareOrdering) {
        return false
      }
    }

    return true
  },
  getDefaultValue({ specsData }: GetDefaultFilterValuePropsType) {
    return 'true'
  },
}
